import {Typography} from "@mui/material";

export const LicenseInfoContent = () => {


    return {
        title: 'Licenses',
        content: (
            <>
                <Typography paragraph>
                    Licenses represent the rights granted for the use,
                    distribution, exhibition, or exploitation of the
                    products being administered by the system.
                </Typography>

                <ul>
                    <li>
                        A License defines who has the right to use a
                        product, where it may be used, and during what
                        period of time.
                    </li>

                    <li>
                        Licenses often include information such as
                        licensee, territory, market, availability dates,
                        execution dates, and financial terms.
                    </li>

                    <li>
                        License data is frequently used in conjunction
                        with Usage, Viewership, and Financial data when
                        calculating obligations and validating product
                        activity.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing License records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        License data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new License manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete License records.
                    </li>

                    <li>
                        Maintaining accurate License information helps
                        ensure that downstream usage, financial, and
                        obligation calculations are based on the correct
                        contractual rights and availability periods.
                    </li>
                </ul>
            </>
        )
    };

};






